import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const SEOHeader = ({ title, description }) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name='description' content={description} />
		</Helmet>
	)
}

SEOHeader.propTypes = {
	title: PropTypes.string.isRequired
}

SEOHeader.defaultProps = {
	title: 'Index'
}

export default SEOHeader
